import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import {
  AssociationsLogosSection,
  CompanyHistory,
  CompanySlider,
  OurPartnersSection,
  OurPartnersSlider,
  ProudMembersSection,
  RedesignLeadershipSlider,
  StringSection,
} from 'containers/about-us';
import {
  bgImageHeader,
  ourParnersSpectrumLogo,
  ourPartnersAlticeLogo,
  ourPartnersAptitudeLogo,
  ourPartnersAstoundLogo,
  ourPartnersATTLogo,
  ourPartnersCharterLogo,
  ourPartnersClearwaveLogo,
  ourPartnersComcastLogo,
  ourPartnersConsolidatedLogo,
  ourPartnersDishLogo,
  ourPartnersEricssonLogo,
  ourPartnersFatbeamLogo,
  ourPartnersFrontierCommunicationsLogo,
  ourPartnersLogo1,
  ourPartnersLogo10,
  ourPartnersLogo11,
  ourPartnersLogo12,
  ourPartnersLogo13,
  ourPartnersLogo14,
  ourPartnersLogo15,
  ourPartnersLogo2,
  ourPartnersLogo3,
  ourPartnersLogo4,
  ourPartnersLogo5,
  ourPartnersLogo6,
  ourPartnersLogo9,
  ourPartnersLumosLogo,
  ourPartnersMaxxSouthLogo,
  ourPartnersTeslaLogo,
  ourPartnersWyyerdLogo,
  slide1,
  slide10,
  slide11,
  slide12,
  slide13,
  slide14,
  slide15,
  slide16,
  slide17,
  slide18,
  slide19,
  slide2,
  slide20,
  slide21,
  slide22,
  slide23,
  slide24,
  slide25,
  slide26,
  slide27,
  slide28,
  slide29,
  slide3,
  slide30,
  slide31,
  slide32,
  slide33,
  slide34,
  slide35,
  slide36,
  slide37,
  slide38,
  slide39,
  slide4,
  slide40,
  slide41,
  slide42,
  slide43,
  slide5,
  slide6,
  slide7,
  slide8,
  slide9,
} from 'images/about-us';
import TeamDescriptionSection from 'containers/about-us/TeamDescriptionSection';
import leadershipList from '../config/about-us/leadershipList';

const AboutUs: NextPage = () => {
  return (
    <>
      <Header
        title="About Us"
        description="Meet the people behind the project and find out more on how they made it a reality."
        hasTextBlock
        image={bgImageHeader}
        listItems={[
          { title: '2016', text: 'Founded' },
          { title: '445', text: 'OSP Projects Completed' },
          { title: '453', text: 'Wireless Sites Installed' },
          { title: '100+', text: 'Engineering Projects Initiated' },
          { title: '200+', text: 'DAS/Small Cells Installed' },
          { title: '1,200+', text: 'Maintenance Projects Completed' },
          { title: '56000+', text: 'Poles Installed' },
        ]}
      />
      <CompanyHistory
        title="Company History"
        listItems={[
          {
            paragraph1:
              'Utilities One was founded in 2016, evolving from our sister company, MoldCable, which focused on cable installation and repair. With a vision to drive impactful change in an ever-evolving tech landscape, Utilities One emerged as a leader in infrastructure solutions.',
          },
          {
            paragraph1:
              'Today, Utilities One delivers comprehensive services across Telecommunications, Power Utilities, Renewable Energy, Water Utilities, Wireless Carriers and Technology Deployment. ',
          },
          {
            paragraph2:
              'As a nationwide Telecom Service Provider, Utilities One supports Wireline ILEC & CLEC providers and Wireless Carriers, offering turnkey Engineering, Design, and Construction services for Wireline Projects, such as FTTx, FTTH, FTTP, FTTC, FTTN, along with maintenance services. ',
          },
          {
            paragraph2:
              'Understanding the pivotal role of Wireless networks, we deliver end-to-end solutions for site builds, modifications, antenna installations, and Small Cell/DAS deployments, with expertise in Site Acquisition, Project Management, and Maintenance.',
          },
          {
            paragraph2:
              'We partner with major Electric providers to build Overhead and Underground Distribution and Transmission lines and lead Grid Modernization with Smart Grid solutions, Emergency Storm Restoration, and Maintenance services.',
          },
          {
            paragraph2:
              'Utilities One Water delivers sustainable, resilient water utility solutions for communities and businesses, from infrastructure and maintenance to storm response and system upgrades, ensuring safe, reliable water access today and for the future. ',
          },
          {
            paragraph2:
              'In Gas Utilities, our Construction and Engineering services span Distribution and Pipeline projects, aligning with leading Gas Utilities nationwide. ',
          },
          {
            paragraph2:
              'Committed to sustainability, Utilities One offers full Design/Build EPC services for Solar Systems, Wind Farms, and EV networks. Founded to reshape the industry, Utilities One is driven by a mission to create positive, lasting impacts that benefit communities and drive progress.',
          },
        ]}
      />
      <CompanySlider
        sliderList={[
          {
            image: slide1,
          },
          {
            image: slide2,
          },
          {
            image: slide3,
          },
          {
            image: slide4,
          },
          {
            image: slide5,
          },
          {
            image: slide6,
          },
          {
            image: slide7,
          },
          {
            image: slide8,
          },
          {
            image: slide9,
          },
          {
            image: slide10,
          },
          {
            image: slide11,
          },
          {
            image: slide12,
          },
          {
            image: slide13,
          },
          {
            image: slide14,
          },
          {
            image: slide15,
          },
          {
            image: slide16,
          },
          {
            image: slide17,
          },
          {
            image: slide18,
          },
          {
            image: slide19,
          },
          {
            image: slide20,
            isHorizontalImg: true,
          },
          {
            image: slide21,
          },
          {
            image: slide22,
          },
          {
            image: slide23,
          },
          {
            image: slide24,
          },
          {
            image: slide25,
          },
          {
            image: slide26,
            isHorizontalImg: true,
          },
          {
            image: slide42,
          },
          {
            image: slide28,
            isHorizontalImg: true,
          },
          {
            image: slide29,
          },
          {
            image: slide30,
          },
          {
            image: slide31,
          },
          {
            image: slide32,
          },
          {
            image: slide33,
          },
          {
            image: slide34,
            isHorizontalImg: true,
          },
          {
            image: slide35,
          },
          {
            image: slide36,
          },
          {
            image: slide37,
          },
          {
            image: slide38,
          },
          {
            image: slide39,
          },
          {
            image: slide40,
          },
          {
            image: slide41,
          },
          {
            image: slide27,
          },
          {
            image: slide43,
          },
        ]}
      />
      <StringSection />
      <RedesignLeadershipSlider sliderList={leadershipList} />
      <TeamDescriptionSection
        title="is being built and maintained by the finest "
        span="Utilities One"
        secondSpan="industry experts"
        text="Our team of experienced professionals works hard to deliver excellent solutions and services to our ever-growing customer community. Every employee contributes exceptional ideas to our progressive initiatives and works cooperatively with our leadership to realize the company's full potential."
      />
      <ProudMembersSection
        title="Proud Members of Esteemed Industry Associations"
        text="we take pride in our industry leadership, consistently delivering outstanding results and maximizing value for our clients. As members of top industry associations, we reinforce our commitment to excellence through partnerships that elevate our services. Recognizing our employees as our greatest asset, we provide direct compensation insurance, ensuring peace of mind and enabling them to focus on delivering exceptional work."
        secondText="Our project managers receive rigorous training and hands-on experience, equipping them to handle projects nationwide with precision. Utilities One holds all necessary State Board of Contractors licenses and Secretary of State certifications, ensuring compliance and expertise in every state we operate. Our extensive network of certified Business Partners allows us to collaborate with the best providers nationwide, guaranteeing innovative solutions without compromise."
        orangeText="Utilities One, "
        startText="At "
      />
      <AssociationsLogosSection />
      <OurPartnersSection
        title="Our Partners"
        text="Utilities One is backed by a network of top technology and consulting partners, spanning the entire industry landscape. We unite passionate, skilled, and driven business owners, leaders, and entrepreneurs, fostering mutually beneficial opportunities that drive a more ambitious and sustainable economy."
        secondText="Our partners are dedicated to leveraging our solutions to enhance customer experiences and boost consumer engagement. Each partner is strategically chosen for their unique expertise across diverse industries, along with their complementary software solutions, services, and equipment offerings."
      />
      <OurPartnersSlider
        sliderList={[
          {
            image: ourPartnersTeslaLogo,
            width: 164,
            height: 16,
            link: 'https://www.tesla.com/',
          },
          {
            image: ourParnersSpectrumLogo,
            width: 140,
            height: 58,
            link: 'https://www.spectrum.com/',
          },
          {
            image: ourPartnersFrontierCommunicationsLogo,
            width: 140,
            height: 58,
            link: 'https://frontier.com/',
          },
          {
            image: ourPartnersLogo6,
            width: 136,
            height: 40,
            link: 'https://www.lumen.com/en-us/home.html',
          },
          {
            image: ourPartnersLogo9,
            width: 60,
            height: 56,
            link: 'https://www.fpl.com/',
          },
          {
            image: ourPartnersComcastLogo,
            width: 140,
            height: 50,
            link: 'https://corporate.comcast.com/',
          },
          {
            image: ourPartnersDishLogo,
            width: 140,
            height: 50,
            link: 'https://www.linkedin.com/company/dish-network/',
          },
          {
            image: ourPartnersLogo1,
            width: 60,
            height: 70,
            link: 'https://www.up.com/index.htm',
          },
          {
            image: ourPartnersLogo2,
            width: 100,
            height: 41,
            link: 'https://www.nrtc.coop',
          },
          {
            image: ourPartnersLogo3,
            width: 131,
            height: 35,
            link: 'https://www.bnsf.com',
          },
          {
            image: ourPartnersLogo4,
            width: 121,
            height: 38,
            link: 'https://www.amazon.com/',
          },
          {
            image: ourPartnersLogo5,
            width: 111,
            height: 49,
            link: 'https://www.americantower.com',
          },
          {
            image: ourPartnersLogo10,
            width: 141,
            height: 50,
            link: 'https://sbasite.com/',
          },
          {
            image: ourPartnersLogo11,
            width: 151,
            height: 51,
            link: 'https://www.kineticinternetdeals.com/',
          },
          {
            image: ourPartnersLogo12,
            width: 151,
            height: 39,
            link: 'https://ziplyfiber.com/',
          },
          {
            image: ourPartnersLogo13,
            width: 120,
            height: 37,
            link: 'https://connectivitywireless.com/',
          },
          {
            image: ourPartnersLogo14,
            width: 131,
            height: 58,
            link: 'https://www.nexteraenergy.com/',
          },
          {
            image: ourPartnersLogo15,
            width: 120,
            height: 38,
            link: 'https://www.sonic.com/',
          },
          {
            image: ourPartnersAstoundLogo,
            width: 140,
            height: 58,
            link: 'https://www.astound.com/',
          },
          {
            image: ourPartnersAptitudeLogo,
            width: 140,
            height: 58,
            link: 'https://aptitudeinternet.com/',
          },
          {
            image: ourPartnersATTLogo,
            width: 140,
            height: 58,
            link: 'https://www.att.com/',
          },
          {
            image: ourPartnersAlticeLogo,
            width: 140,
            height: 58,
            link: 'https://www.alticeusa.com/',
          },
          {
            image: ourPartnersFatbeamLogo,
            width: 140,
            height: 58,
            link: 'https://www.fatbeam.com/',
          },
          {
            image: ourPartnersEricssonLogo,
            width: 140,
            height: 58,
            link: 'https://www.ericsson.com/en',
          },
          {
            image: ourPartnersMaxxSouthLogo,
            width: 140,
            height: 58,
            link: 'https://www.maxxsouth.com/',
          },
          {
            image: ourPartnersCharterLogo,
            width: 140,
            height: 50,
            link: 'https://corporate.charter.com/',
          },
          {
            image: ourPartnersClearwaveLogo,
            width: 140,
            height: 50,
            link: 'https://www.clearwavefiber.com/',
          },
          {
            image: ourPartnersConsolidatedLogo,
            width: 140,
            height: 50,
            link: 'https://www.linkedin.com/company/consolidated-communications/',
          },
          {
            image: ourPartnersWyyerdLogo,
            width: 140,
            height: 50,
            link: 'https://www.wyyerd.com/',
          },
          {
            image: ourPartnersLumosLogo,
            width: 140,
            height: 50,
            link: 'https://www.lumosfiber.com/',
          },
        ]}
      />
    </>
  );
};

export default AboutUs;
